import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import { FeedbackAlert } from '../../../../lib/components/atomic/feedback';
import Util from '../../../../misc/util';

interface Props {
  data?: Record<string, string | number | null | undefined>;
}

export const CompanyDefaultValuesView: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <DataGrid>
      <Grid item xs={12}>
        <FeedbackAlert
          description={t(
            data?.defaultBenefitBudget || data?.defaultBenefitSet
              ? 'company:DEFAULT_ASSIGNMENT_HINT'
              : 'company:DEFAULT_ASSIGNMENT_NONE'
          )}
          severity="info"
        />
      </Grid>

      <DataGridElement
        title={t('company:DEFAULT_BUDGET')}
        value={Util.formatCurrency(data?.defaultBenefitBudget as number)}
      />
      <DataGridElement
        title={t('company:DEFAULT_BENEFIT_SET')}
        value={data?.defaultBenefitSetName}
      />
    </DataGrid>
  );
};
